export enum FeatureFlag {
	NEW_AUTOCOMPLETE_API = 'new_autocomplete_api',
}

type Environment = 'prod' | 'acpt' | 'int' | 'dev'

type FeatureFlagConfig = {
	enabled: boolean
	languages?: string[]
}

const featureFlagConfig: Record<Environment, Record<FeatureFlag, FeatureFlagConfig>> = {
	prod: {
		[FeatureFlag.NEW_AUTOCOMPLETE_API]: { enabled: true },
	},
	acpt: {
		[FeatureFlag.NEW_AUTOCOMPLETE_API]: { enabled: true },
	},
	int: {
		[FeatureFlag.NEW_AUTOCOMPLETE_API]: { enabled: true },
	},
	dev: {
		[FeatureFlag.NEW_AUTOCOMPLETE_API]: { enabled: true },
	},
}

export const getFeatureFlagConfig = (
	flag: FeatureFlag,
	environment: Environment
): FeatureFlagConfig => {
	return featureFlagConfig[environment]?.[flag] || { enabled: false }
}

export const resolveEnvironment = (nodeEnv?: string): Environment => {
	switch (nodeEnv) {
		case 'prod':
		case 'production':
			return 'prod'
		case 'acpt':
			return 'acpt'
		case 'int':
			return 'int'
		default:
			return 'dev'
	}
}
